'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = _assign2.default || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = require('material-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles() {
  return {
    input: {
      backgroundColor: '#F8FAFC',
      marginTop: '20px',
      padding: '8px'
    },
    error: {
      color: '#ff1744',
      marginTop: '8px'
    }
  };
};

var TextInput = function TextInput(_ref) {
  var disabled = _ref.disabled,
      classes = _ref.classes,
      input = _ref.input,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error;
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(_materialUi.Input, _extends({}, input, {
      error: Boolean(touched && error),
      className: classes.input,
      fullWidth: true,
      disabled: disabled
    })),
    touched && error ? _react2.default.createElement(
      'div',
      { className: classes.error },
      error
    ) : null
  );
};

TextInput.propTypes = {
  classes: _propTypes2.default.object,
  input: _propTypes2.default.object.isRequired,
  meta: _propTypes2.default.object.isRequired,
  disabled: _propTypes2.default.bool
};

TextInput.defaultProps = {
  classes: {},
  disabled: false
};

exports.default = (0, _materialUi.withStyles)(styles)(TextInput);